import { useQuery } from 'react-query'

import { request } from '../api/apiCore'

const fetchUser = id => request({ url: `/users/${id}.json` })

export const useUserData = id => useQuery(['user', id], () => fetchUser(id))
